import { PromptTemplateCategory } from '../types';

export const creative: PromptTemplateCategory = {
  title: "クリエイティブ",
  icon: "✨",
  templates: [
    {
      title: "おやすみ前のお話",
      content: `小さな子供のための優しいおやすみ前のお話を、読み聞かせ向けに作成してください。
- 主人公は[優しい小さなキツネ]で、名前は[ヘーゼル]です。
- 物語の舞台は[夜になるとランタンが灯る居心地の良い森の村]です。
- 主人公は小さくて穏やかな課題に直面します：[曇り空でお気に入りの星が見つからないので、ホタルを追って丘の上まで行きます]。
- [良いものは見えなくても必ずそこにあると信じる心と忍耐]を教える平和な結末で締めくくってください。
- 声に出して読んだとき自然に聞こえる、短くリズミカルな文章を使ってください。`
    },
    {
      title: "短編小説ナレーション",
      content: `オーディオブック風のナレーションに適した短編小説を書いてください。
- ジャンル：[現代ミステリー]。
- 主人公は[新しい隣人の日課に何か不思議なことに気づいた引退した図書館員]です。
- 中心的な緊張感は[小さな説明のつかない詳細が積み重なり、驚きながらも満足のいく真相へと向かう]ことです。
- トーン：[温かみのある静かなサスペンス]。
- リスナーの興味を引き続けるために、文の長さを変えながら明確で流れるようなスタイルで書いてください。`
    },
    {
      title: "詩の朗読",
      content: `声に出して朗読するための詩を書いてください。
- テーマ：[夜明けに目覚める街の感覚]。
- スタイル：[自然な話し言葉のリズムを持つ自由詩]。
- ムード：[内省的で希望に満ちた]。
- 鮮やかな感覚的描写を含めてください：[始発バスの音、濡れた舗道に差す光、パン屋から漂う焼きたてのパンの香り]。
- 読み手のペースと呼吸を導く間（ま）と行の区切りを使ってください。`
    }
  ]
};
